export default __webpack_public_path__ + "static/media/value-list.324118fe.svg";